import React from 'react'
import PropTypes from 'prop-types'

import Menu from './components/menu'

import * as styles from './styles'

const LayoutComponent = ({ children }) => (
  <div css={styles.container}>
    <Menu css={styles.menu} />
    <div css={styles.main}>
      <section css={styles.section}>{children}</section>
    </div>
  </div>
)

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutComponent
